import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";

/**
 * Shared "are you sure you want to submit?" dialog used by every exam-style
 * flow. The caller controls the copy (`message`) and the destructive action;
 * styling is fixed so every flow looks consistent.
 */
const ConfirmSubmitDialog = ({
  open,
  onClose,
  onConfirm,
  message = "Are you sure you want to submit the TOEIC test?",
  confirmLabel = "Submit",
  cancelLabel = "Cancel",
  isSubmitting = false,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    PaperProps={{
      sx: {
        borderRadius: 4,
        p: 0,
        background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
        boxShadow: "0 20px 60px rgba(33, 150, 243, 0.15)",
        border: "1px solid rgba(33, 150, 243, 0.1)",
      },
    }}
  >
    <DialogContent sx={{ p: 4, textAlign: "left" }}>
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>{cancelLabel}</Button>
      <Button onClick={onConfirm} disabled={isSubmitting}>
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmSubmitDialog;
